<div
    class="subscription-btn {{themeService.isDarkMode ? 'dark': 'light'}}"
    [style.--background]="'#ffffff'"
    [style.border]="'2px solid ' + sideColors[sideName === 'side1' ? 0 : 1]"
    translate
    [style.height.px]="rowHeight * 1"
    [style.font-size.px]="rowHeight / 5"
    (click)="showSubstitutionModal(sideName === 'side1' ? 1 : 2)"
    [style.pointer-events]="remainingSubstitute === 0 ? 'none' : 'auto'">
    <div class="subscription-wrap" [style.gap.px]="rowHeight / 10">
        <div class="subscription-title" [style.font-size.px]="rowHeight / 5" [style.height.px]="rowHeight / 5">{{'SUBS' | translate}}</div>

        <div class="subscription-dots">
            @if (!match?.substitutionPolicy || (match?.substitutionPolicy.perMatch === 0 && match?.substitutionPolicy.perSet === 0)) {
                <span [style.font-size.px]="rowHeight / 3.5" [style.height.px]="rowHeight / 3" class="na">{{'N/A' | translate}}</span>
              } @else {
                <span [style.font-size.px]="rowHeight / 3" [style.height.px]="rowHeight / 3">
                    @if(isSubstituteInfinite){
                        <ion-icon [style.font-size.px]="rowHeight / 2.5" class="infinite-icon" name="infinite"></ion-icon>
                    } @else {
                        {{remainingSubstitute}}
                    }
                </span>
              }
        </div>
    </div>
</div>
@if (match) {
    <app-tracker-board
      hidden
      [match]="match"
      #board
      [shotStatsBoard]="false"
    ></app-tracker-board>

    <app-tracker-bar
      hidden
      [match]="match"
      #trackerBar
      [isTracker]="false"
      [isOwner]="false"
      (stopTimedSet)="board.completeTimedSet()"
    ></app-tracker-bar>
}